var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/contract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/contract",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78872176,18.5499992 L3.78872194,18.5499992 C2.29755321,18.5499992 1.0887221,17.3411679 1.0887221,15.8499991 L1.0887221,14.0499992 L1.0887221,14.0499992 L6.78872176,14.0499992",
    id: "Path",
    stroke: "#ffffff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9387212,3.54999985 L15.9387212,16.5742178 C15.9387212,17.9825438 14.7970474,18.5499998 13.3887214,18.5499998 L6.1887218,18.5499998 M3.63872195,14.0734816 C3.63872195,11.7349301 3.63872195,8.22710287 3.63872195,3.54999985 C3.63872195,2.14167382 4.78039577,1 6.1887218,1 L13.3887214,1 L17.2137211,1",
    id: "Shape",
    stroke: "#ffffff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.86372176,
    y1: 10.8249994,
    x2: 12.4137214,
    y2: 10.8249994,
    id: "Line",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2137211,1 C17.9178842,1 18.4887211,1.57083691 18.4887211,2.27499992 L18.4887211,5.79999971 L18.4887211,5.79999971 L15.9387212,5.79999971 L15.9387212,2.27499992 C15.9387212,1.57083691 16.5095581,1 17.2137211,1 Z",
    id: "Rectangle",
    stroke: "#ffffff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14999999,17.649999 L1.14999999,15.1257804 C1.14999999,14.5316429 1.78799418,14.0499992 2.57499991,14.0499992 C3.36200563,14.0499992 3.99999982,14.5316429 3.99999982,15.1257804 L3.99999982,17.649999 L15.9387212,17.649999",
    id: "Path",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    transform: "translate(8.544361, 15.849999) rotate(180.000000) translate(-8.544361, -15.849999) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.86372176,
    y1: 5.42499974,
    x2: 12.4137214,
    y2: 5.42499974,
    id: "Line",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.86372176,
    y1: 8.12499958,
    x2: 12.4137214,
    y2: 8.12499958,
    id: "Line",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractWhite);
export default __webpack_public_path__ + "static/media/contract-white.96ce9f86127013e0f6bc8580f4c1d339.svg";
export { ForwardRef as ReactComponent };